import { StarBgWrapper } from './styles';

export interface StarConfig {
  count: number;
  delay: number;
  smallSize: number;
  mediumSize: number;
  largeSize: number;
}

export const defaultStarConfig = {
  count: 20,
  smallSize: 40,
  mediumSize: 60,
  largeSize: 80,
  delay: 4,
};

function getStartList(stars = 30, { smallSize, mediumSize, largeSize, delay }) {
  const list = [];
  let size = 'small';
  const sparkle = delay;
  const sizeMap = {
    small: smallSize,
    medium: mediumSize,
    large: largeSize,
  };
  for (let i = 0; i < stars; i++) {
    if (i % 2 === 0) {
      size = 'small';
    } else if (i % 3 === 0) {
      size = 'medium';
    } else {
      size = 'large';
    }

    list.push({
      style: {
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${sizeMap[size]}px`,
        height: `${sizeMap[size]}px`,
        WebkitAnimationDelay: `${Math.random() * sparkle}s`,
        MozAnimationDelay: `${Math.random() * sparkle}s`,
      },
      // className: size,
    });
  }
  return list;
}

const StarShine = ({
  count = 30,
  smallSize = 20,
  mediumSize = 30,
  largeSize = 50,
  delay = 10,
} = {}) => {
  const starList = getStartList(count, {
    smallSize,
    mediumSize,
    largeSize,
    delay,
  });
  return (
    <StarBgWrapper>
      {starList.map((star, index) => {
        return (
          <div
            className={'template shine '}
            style={star.style}
            key={index}
          ></div>
        );
      })}
    </StarBgWrapper>
  );
};

export default StarShine;
